import { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { T, COMMON } from '../../common/js/i18n';

interface Props {
    onClose?: () => void;
}

interface State {
    url: string;
    done: boolean;
}

export default class PublicNavigator extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            url: "",
            done: false
        };
    }
    render() {
        if (this.state.done) {
            return (
                <Navigate to={this.state.url.substring((window.location.protocol + "//" + window.location.host + window.location.pathname + "#").length)} />
            );
        } else {
            let urlPrefix = window.location.protocol + "//" + window.location.host + window.location.pathname + "#/open/";
            let urlValid = !!this.state.url && this.state.url.startsWith(urlPrefix);
            return (
                <div style={{ padding: "0.5em" }}>
                    <div>
                        <span>{T({ en: "Url of shared scheme", zh: "共享方案链接" })}:</span>
                        <input type="text" value={this.state.url} onInput={(evt) => {
                            this.setState({
                                url: (evt.target as any).value || ""
                            });
                        }} style={{ width: "32em", marginLeft: "0.5em" }} />
                    </div>
                    <div style={{ textAlign: "center", paddingTop: '0.5em' }}>
                        <button type="button" className="btn" disabled={!urlValid} onClick={() => {
                            if (urlValid) {
                                this.setState({
                                    done: true
                                });
                            }
                        }}>{T(COMMON.OK)}</button>
                        <button type="button" className="btn" onClick={() => {
                            if (this.props.onClose) {
                                this.props.onClose();
                            }
                        }}>{T(COMMON.CANCEL)}</button>
                    </div>
                </div>
            );
        }
    }
}
